module.exports = __webpack_public_path__ + "static/media/43.f62e4bb1.png";